import {
  CommonModelClassId,
  SelectiveSyncFilterSchema,
  UserFacingFilterType,
} from "../../../autogenerated-types/AUTOGENERATED_ExpandedPydantic_SelectiveSyncFilterSchema";

export enum SelectSyncFilterOperators {
  GREATER_THAN = "Greater than",
  LESS_THAN = "Less than",
  EQUAL_TO = "Equal to",
}

export enum ConditionType {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  DATE_TIME = "DATE_TIME",
  INTEGER = "INTEGER",
  FLOAT = "FLOAT",
  STRING = "STRING",
}

export enum DatetimeFormatEnum {
  ISO_FORMAT = "ISO_FORMAT",
  ISO_FORMAT_SECONDS = "ISO_FORMAT_SECONDS",
  ISO_FORMAT_TIMEZONE = "ISO_FORMAT_TIMEZONE",
  MILLISECONDS = "MILLISECONDS",
  SECONDS = "SECONDS",
}

// Currently the condition operators we support are spread across 4 different enums,
// ConditionListOperator, ConditionStringOperator, ConditionComparableOperator and ConditionBooleanOperator
export enum ConditionListOperator {
  IS_ONE_OF = "IS_ONE_OF",
  HAS_ALL_OF = "HAS_ALL_OF",
  HAS_NONE_OF = "HAS_NONE_OF",
}

export type ConditionStringOperator = "CONTAINS" | "EQUALS" | "NOT_EQUALS";

export type ConditionComparableOperator =
  | "GREATER_THAN"
  | "GREATER_THAN_OR_EQUAL_TO"
  | "LESS_THAN"
  | "LESS_THAN_OR_EQUAL_TO"
  | "EQUALS"
  | "NOT_EQUALS"
  | "CONTAINS";

export type ConditionBooleanOperator = "EQUALS" | "NOT_EQUALS";

// Combine all condition operators into a single type
export type ConditionOperator =
  | ConditionListOperator
  | ConditionStringOperator
  | ConditionComparableOperator
  | ConditionBooleanOperator;

export const CONDITION_OPERATORS: Record<ConditionOperator, string> = {
  IS_ONE_OF: "Is one of",
  HAS_ALL_OF: "Has all of",
  HAS_NONE_OF: "Has none of",
  CONTAINS: "Contains",
  EQUALS: "Equals",
  NOT_EQUALS: "Not equals",
  GREATER_THAN: "Greater than",
  GREATER_THAN_OR_EQUAL_TO: "Greater than or equal to",
  LESS_THAN: "Less than",
  LESS_THAN_OR_EQUAL_TO: "Less than or equal to",
};

// NOTE: Derive from RequestLocation in AUTOGENERATED types
export enum FilterLocationEnum {
  BODY = "BODY",
  PATH = "PATH",
  QUERY = "QUERY",
  HEADER = "HEADER",
}

export enum CompositeFilterEnum {
  ODATA = "ODATA",
  INTERCOM_QUERY_LANGUAGE = "INTERCOM_QUERY_LANGUAGE",
  HUBSPOT_FILTER_GROUPS = "HUBSPOT_FILTER_GROUPS",
}

export enum ListDelimiterEnum {
  Comma = ",",
  "Custom delimiter" = "Custom delimiter",
}

export interface AbstractConditionValue {
  value: string | string[];
  typed_value: string | string[];
}

export interface AbstractCondition {
  operator: string;
  value: AbstractConditionValue;
  integration_id: string | null;
  filter_type_id: string;
}

export interface BlueprintVersionMeta {
  blueprint_version_id: string;
  blueprint_name: string;
}

export interface AutomatedModifiedAtFilter {
  id: string;
  common_model_id: CommonModelClassId;
  category: string;
  blueprint_version_ids: string[];
}

export interface AutomatedModifiedAtFilterDetails {
  amf_model: AutomatedModifiedAtFilter;
  blueprint_details: BlueprintVersionMeta[];
  num_linked_account_conditions: number;
  existing_filter: SelectiveSyncFilterSchema | null;
}

export interface UserFacingFilterTypes {
  staged_filter_types: { [id: string]: UserFacingFilterType };
  published_filter_types: { [id: string]: UserFacingFilterType };
}
